import React from 'react';
import styled, { css } from 'styled-components';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import NavLink from './nav-link';
import ChildLink from './child-link';
import useMenuItems from '../../../hooks/use-menu-items';
import useActiveMenu from '../../../hooks/use-active-menu';

const borderStyle = css`
  border-bottom: 1px solid ${({ theme }) => theme.pages.coverNav.borderColor};
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  background-color: transparent;
  border: none;
  padding: 0;
  margin-left: auto;
  color: ${({ theme }) => theme.pages.coverNav.buttonColor};
  svg {
    width: .75rem;
    margin-left: .25rem;
  }
`;
const ButtonWrapper = styled.div`
  ${borderStyle}
  padding: 1rem ${({ theme }) => theme.grid.columnGap};
`;

const ItemWrapper = styled.div`
  padding: ${({ theme }) => theme.pages.coverNav.itemWrapperPadding};
  &:not(:last-child) {
    ${borderStyle}
  }
`;

const CoverNav = ({
  className,
  setCoverOpen,
  activeClassName,
  pageId,
  mustHaveSubpages = true,
}) => {
  const { menuitems } = useMenuItems();
  // activeMenu is used to check if a page has active children and add active styling
  const activeMenu = useActiveMenu({ pageId, mustHaveSubpages });

  return (
    <div className={className}>
      <ButtonWrapper>
        <Button
          type="button"
          onClick={() => setCoverOpen(false)}
        >
          sluiten
          <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          >
            <path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" />
          </svg>
        </Button>
      </ButtonWrapper>
      {menuitems && menuitems.length > 0 && menuitems.map(({
        id,
        page,
        subpage = [],
        externalpage,
      }) => (page || externalpage) && (
        <ItemWrapper key={id}>
          {externalpage && (
            <NavLink as={OutboundLink} href={externalpage.externalLink}>
              {externalpage.externalTitle}
            </NavLink>
          )}
          {!externalpage && (
            <NavLink
              activeClassName={activeClassName}
              className={activeMenu?.page?.slug === page.slug ? activeClassName : ''}
              to={page.slug}
            >
              {page.title}
            </NavLink>
          )}
          {subpage && subpage.length > 0 && subpage.map(({ title, slug, subpageId }) => (
            <ChildLink
              key={subpageId}
              activeClassName={activeClassName}
              partiallyActive
              to={slug}
            >
              {title}
            </ChildLink>
          ))}
        </ItemWrapper>
      ))}
    </div>
  );
};

export default styled(CoverNav)`
  z-index: 9;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: scroll;
  background-color: ${({ theme }) => theme.pages.coverNav.backgroundColor};
`;
